export const getHost = () => {
  if (typeof window === 'undefined') {
    return 'https://www.which.co.uk'
  }
  return window.location?.host ? `${window.location?.protocol}//${window.location?.host}` : ''
}
